import classNames from 'classnames';

import { Wysiwyg } from '@jsmdg/yoshi';
import { type ContentBlock } from '../../../shared/types';
import styles from './ProductServiceInfo.module.scss';

const addULClass = (htmlString: string): string => {
    const ulPattern = /<ul[^>]*>([\s\S]*?)<\/ul>/g; // eslint-disable-line unicorn/better-regex, regexp/no-unused-capturing-group
    const liPattern = /<li[^>]*>[\s\S]*?<\/li>/g; // eslint-disable-line unicorn/better-regex

    const modifiedHtml = htmlString.replaceAll(ulPattern, match => {
        const liMatches = match.match(liPattern);

        if (liMatches && liMatches.length > 6) {
            return match.replace('<ul', `<ul class="${styles.longList}"`);
        }

        return match;
    });

    return modifiedHtml;
};

type ProductServiceInfoProps = {
    readonly content: ContentBlock;
};

const ProductServiceInfo = ({ content }: ProductServiceInfoProps): JSX.Element => {
    const { body, caption } = content;

    return (
        <div className={classNames('pt-4x pt-sm-0 pb-4x pb-sm-2x', styles.container)}>
            <h2 className={classNames('fw-bold pb-3x', styles.caption)}>{caption}</h2>
            <Wysiwyg content={addULClass(body)} />
        </div>
    );
};

export { ProductServiceInfo };
